import Vue from 'vue'
import { X_TOKEN } from '@/data/Constant'
import axios from './$axios'

function setToken (token) {
  Vue.ls.set(X_TOKEN, token)
}

function clearToken () {
  Vue.ls.clear()
}

export default axios

export {
  setToken,
  clearToken
}
export { default as User } from './modules/User'
export { default as Code } from './modules/Code'
export { default as Organization } from './modules/Organization'
export { default as Teacher } from './modules/Teacher'
export { default as Video } from './modules/Video'
export { default as Stars } from './modules/Stars'
export { default as Course } from './modules/Course'
export { default as Character } from './modules/Character'
export { default as Font } from './modules/Font'
export { default as FontCharacter } from './modules/FontCharacter'
export { default as Creation } from './modules/Creation'
export { default as Credits } from './modules/Credits'
export { default as Orders } from './modules/Orders'
export { default as Commodities } from './modules/Commodities'
export { default as Vip } from './modules/Vip'
export { default as Wechat } from './modules/Wechat'
export { default as Stages } from './modules/Stages'
export { default as SystemConfig } from './modules/SystemConfig'
export { default as Applet } from './modules/Applet'
